<template>
	<section class="agreement">
		<Nav title="查看协议" />
		<van-cell title="应用隐私协议" is-link @click="lookFn('yinsi')" />
		<van-cell title="用户服务协议" is-link @click="lookFn('yonghu')" />
		<van-cell title="委托推广协议" is-link @click="lookFn('kehu')" />
		<Login :isLoginModel="isLoginModel" :type="type" :topLeftArrow="topLeftArrow" @closeModel="closeModel"/>
	</section>
</template>

<script>
import Nav from "components/Nav"
import Login from "components/Login"

export default {
	name: 'agreement',
	components: {
		Nav,
		Login,
	},
	data() {
		return {
			isLoginModel: false,
			topLeftArrow: true,
			type:''
		}
	},
		mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},
	methods: {
		lookFn(type) {
			this.isLoginModel= true,
			this.type = type
		},
		closeModel() {
			this.isLoginModel = false
		}
	}
}
</script>

<style lang="scss">
	.agreement {
		padding-top: 46px;
		.van-cell {
			height: 56px;
			align-items: center;
			padding: 0 16px;
			color: #2B2F3A;
			border-top: 1Px solid #f6f6f6;
		}
		.van-cell__title {
			font-size: 16px;
		}
		.van-icon__image, .check {
			width: 26px;
			height: 26px;
		}
		.van-cell__right-icon {
			font-size: 18px;
			color: #2B2F3A;
		}
		.van-cell::after {
			display: none;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/setting/agreement/Agreement.vue